import { GeoPoint } from '@core/const';
import { CityActions } from '../actions';

export const initialState: GeoPoint = undefined;

export function reducer(state = initialState, action: CityActions.UserGeoPointAction): GeoPoint {
  switch (action.type) {
    case CityActions.USER_GEO_POINT_UPDATE: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
}
